<template>
<div>
    <bar-manut 
        single-entity="NCM" 
        plural-entity="NCMs" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="ncm.ncm" :metadata="metadata.ncm.ncm" type="text" col="2" 
                    :disabled="editing" name="ncm" :v-errors="errors" v-validate="metadata.ncm.ncm.validator"></form-field>

                <form-field v-model="ncm.descricao" type="text" col="6" :metadata="metadata.ncm.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.ncm.descricao.validator"></form-field>

                <form-field v-model="ncm.aipi" type="value" col="2" :metadata="metadata.ncm.aipi" :precision="2"
                    name="aipi" :v-errors="errors" v-validate="metadata.ncm.aipi.validator"></form-field>

                <!-- <form-field v-model="ncm.ripi" type="value" col="2" :metadata="metadata.ncm.ripi" :precision="2"
                    name="ripi" :v-errors="errors" v-validate="metadata.ncm.ripi.validator"></form-field> -->

                <form-field v-model="ncm.cest" type="number" col="2" :metadata="metadata.ncm.cest"
                    name="cest" :v-errors="errors" v-validate="metadata.ncm.cest.validator"></form-field>

                <!-- <form-field v-model="ncm.apis" type="value" col="2" :metadata="metadata.ncm.apis" :precision="2"
                    name="apis" :v-errors="errors" v-validate="metadata.ncm.apis.validator"></form-field>
                    
                <form-field v-model="ncm.rpis" type="value" col="2" :metadata="metadata.ncm.rpis" :precision="2"
                    name="rpis" :v-errors="errors" v-validate="metadata.ncm.rpis.validator"></form-field>

                <form-field v-model="ncm.acofins" type="value" col="2" :metadata="metadata.ncm.acofins" :precision="2"
                    name="acofins" :v-errors="errors" v-validate="metadata.ncm.acofins.validator"></form-field>

                <form-field v-model="ncm.rcofins" type="value" col="2" :metadata="metadata.ncm.rcofins" :precision="2"
                    name="rcofins" :v-errors="errors" v-validate="metadata.ncm.rcofins.validator"></form-field> -->
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            ncm: {...this.$store.getters.getEntities.ncm},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadNcm', { id: this.index } )
            if (this.$store.getters.getNcm) {
                this.ncm = {...this.$store.getters.getNcm}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/ncm/' + this.ncm.ncm

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/ncm/'
            var sendData = {}

            sendData = { ncm: this.ncm }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ncm-form.vue